import { render, staticRenderFns } from "./HeaderGameSubmit.vue?vue&type=template&id=6260d45c"
import script from "./HeaderGameSubmit.vue?vue&type=script&lang=js"
export * from "./HeaderGameSubmit.vue?vue&type=script&lang=js"
import style0 from "./HeaderGameSubmit.vue?vue&type=style&index=0&id=6260d45c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports